/**
 * The hooks call the client untyped and type each answer with the generated
 * schema. The contract once declared these answers with a wildcard media type
 * (the generated client typed them `never`); every accounting answer is JSON now.
 * shortcut: requests and answers sent through here go unchecked by the compiler;
 * move each caller onto the typed client, as batch approval is.
 */
import type { ApiError } from "@linkhr/api-client/core";

export interface Init {
  params?: { path?: Record<string, string>; query?: Record<string, unknown> };
  body?: unknown;
  headers?: Record<string, string>;
  /** A file answer (CSV): the client hands back a Blob instead of parsing JSON. */
  parseAs?: "blob";
}
type Call = (path: string, init?: Init) => Promise<{ data?: unknown; error?: unknown }>;
export interface Untyped {
  GET: Call;
  PUT: Call;
  POST: Call;
  PATCH: Call;
  DELETE: Call;
}

export async function answer<T>(call: Promise<{ data?: unknown; error?: unknown }>): Promise<T> {
  const res = await call;
  if (res.error !== undefined) throw res.error as ApiError;
  return res.data as T;
}

/** The company-scoped accounting routes. */
export const COMPANY = "/api/v1/accounting/companies/{companyId}";
